'use client';

import { Box, Button } from '@mui/material';

import { ComponentErrorBoundary } from '@/components';
import { useT } from '@/hooks';

interface SearchFiltersListItem {
  label: string;
  value: string;
}

interface SearchFiltersListProps {
  filters: SearchFiltersListItem[];
  onFilterClick: (value: string) => void;
  activeValue: string;
}

export const SearchFiltersList = ({
  filters,
  onFilterClick,
  activeValue,
}: SearchFiltersListProps) => {
  const { t } = useT();
  const renderFilterButton = (filter: SearchFiltersListItem) => {
    const isActive = filter.value === activeValue;

    return (
      <Button
        key={filter.value}
        variant="text"
        onClick={() => onFilterClick(filter.value)}
        sx={{
          color: isActive ? 'text.primary' : 'text.secondary',
          bgcolor: isActive ? 'action.selected' : 'transparent',
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: isActive ? 600 : 500,
          py: 0.5,
          px: 1.5,
          borderRadius: 2,
          minWidth: 'auto',
          '&:hover': {
            bgcolor: isActive ? 'action.selected' : 'action.hover',
            color: 'text.primary',
          },
        }}
      >
        {t(`filter.${filter.label}`)}
      </Button>
    );
  };

  const renderFilterButtons = filters?.map(renderFilterButton) || [];

  return (
    <ComponentErrorBoundary componentName="SearchFiltersList">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mt: 1,
          flexWrap: 'wrap',
        }}
      >
        {renderFilterButtons}
      </Box>
    </ComponentErrorBoundary>
  );
};
